import createEmptyStatsWrapper from './helpers/create-empty-stats-wrapper';
import { ChannelAnalyticsState } from './types';

export const initialState: ChannelAnalyticsState = {
  ChannelAllChartData: createEmptyStatsWrapper(),
  ChannelSessionsTotal: createEmptyStatsWrapper(),
  ChannelProjects: createEmptyStatsWrapper(),
  ChannelUniqueAttendance: createEmptyStatsWrapper(),
  ChannelAverageUserWatchtime: createEmptyStatsWrapper(),
  ChannelUniqueRegistrations: createEmptyStatsWrapper(),
};
